import { render, staticRenderFns } from "./SMenu.vue?vue&type=template&id=2c1b027a&scoped=true"
import script from "./SMenu.vue?vue&type=script&lang=js"
export * from "./SMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b027a",
  null
  
)

export default component.exports